import * as React from "react";
import { IGameTop } from "../../../api_types";
import { TopTrainingBox } from "../../../styles/Racelive";

interface IProps {
  data: IGameTop;
  type: boolean;
}

const TrainingTop = ({ data, type }: IProps) => {
  return (
    <TopTrainingBox isMatch={type}>
      <div className="trainning">
        <div className="">扫描期间</div>
      </div>
      <div className="trainning">
        <div className="flexCol">
          <div className="">{data.StringClockStart}</div>
          <div className="">开始时间</div>
        </div>
      </div>
      <div className="trainning">
        <div className="flexCol">
          <div className="">{data.ClockStop.replace(/T/g, " ")}</div>
          <div className="">结束时间</div>
        </div>
      </div>
    </TopTrainingBox>
  );
};

export default TrainingTop;
